import React from 'react';
import styles from './HeaderActions.module.scss';

const ButtonDivider = () => {
  return <div className={styles.buttonDivider} />;
};

export default ButtonDivider;
